/**
 * Admin import pages: start over. A full page load (not a rill navigation)
 * is the one thing that also empties the file input and the typed values.
 */
const ResetButton = ({ path }) => (
  <button
    type="button"
    data-button-type="secondary"
    onClick={() => window.location.assign(path)}
  >
    Reset
  </button>
);

export default ResetButton;
